#import "~/graphql/fragments/assets/image.graphql"
#import "~/graphql/fragments/fields/downloads.graphql"
#import "~/graphql/fragments/fields/category.graphql"

fragment grantIssuedSection on grantIssued_Entry {
  featuredImage {
    ... image
    kind
    mimeType
    originalUrl: url
  }
  vimeoUrl
  id
  title
  grant {
    title
  }
  legacyGrant
  yearIssued
  applicantName
  amountIssued
  shortDescription
  website: externalUrl
  downloads {
      ... downloads
  }
  discipline {
      ... category
  }
  additionalTags {
      ... category
  }
}
